import React, { memo, Fragment, useEffect, useCallback, useMemo } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import AxiomSelect from "__AxiomComponents/AxiomSelect/AxiomSelect";
import AxiomMultiSelectCheckboxes from "__AxiomComponents/AxiomMultiSelectCheckboxes/AxiomMultiSelectCheckboxes.js";
import DateRangeSelection from "__AxiomComponents/DateRangeSelection/DateRangeSelection";

import { useFilterTags } from "./HawkeyeV2FieldSelectionHooks";

import "./HawkeyeV2FieldSelection.scss";

function HawkeyeV2FieldSelection(props) {
  const [state, dispatch] = useAxiomState(
    {},
    props.appName,
    props.appID,
    "HawkeyeV2FieldSelection",
    props.componentID
  );

  const {
    selectedView,
    selectedColumns,
    onColumnSelection,
    updateFromDate,
    updateToDate,
    toDate,
    fromDate,
    KPIWiseFilters,
    KPIWiseLocalFilters,
    granularityColumn,
    updateGranularityColumn,
    onSelectionCompletion,
  } = props;

  const filterTags = useFilterTags(selectedView, KPIWiseFilters, KPIWiseLocalFilters);

  const toggleCheckUncheckAll = () => {
    if (selectedColumns.length > 0) {
      onColumnSelection(null, []);
    } else {
      onColumnSelection(null, selectedView.metadata.columns);
    }
  };

  const granularityOptions = useMemo(() => {
    if (selectedView) {
      const granularityOptions = [];
      for (let column in selectedView.metadata.minMaxDates) {
        granularityOptions.push({ label: column, value: column });
      }
      return granularityOptions;
    } else {
      return [];
    }
  }, [selectedView]);

  return (
    <div className={"hawkeye-filter-create-section hawkeye-filter-create-values"}>
      {granularityOptions.length > 1 && (
        <div className="hawkeye-data-selection-section">
          <h3 className="hawkeye-data-selection-title">Select granularity column</h3>
          <AxiomSelect
            placeholder={"Select Granularity Column"}
            options={granularityOptions}
            onChange={updateGranularityColumn}
            value={granularityColumn}
          />
        </div>
      )}

      {granularityColumn && selectedView && (
        <div className="hawkeye-data-selection-section">
          <h3 className="hawkeye-data-selection-title">
            Select time period from {granularityColumn}
          </h3>
          <DateRangeSelection
            className="hawkeye-data-date-range"
            fromUpdate={updateFromDate}
            toUpdate={updateToDate}
            selectionRange={selectedView.metadata.minMaxDates[granularityColumn]}
            from={fromDate}
            to={toDate}
          />
        </div>
      )}

      {filterTags.length > 0 && (
        <div className="hawkeye-data-selection-section">
          <h3 className="hawkeye-data-selection-title">Filters applied</h3>
          <div className="hawkeye-data-filter-tags">
            {filterTags.map((t) => (
              <div key={t.filterDimension} className="hawkeye-data-filter-tag">
                <label className="hawkeye-data-filter-label">{t.filterDimension}</label>
                <ul className="hawkeye-data-filter-values">
                  <b className="hawkeye-data-filter-title">Selected Values</b>
                  {t.filterDimensionValues.map((v) => (
                    <li className="hawkeye-data-filter-value" key={v}>
                      {v}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedView && (
        <div className="hawkeye-data-selection-section">
          <h3 className="hawkeye-data-selection-title">Select required columns to download </h3>
          <div className="hawkeye-data-columns-selection">
            <AxiomMultiSelectCheckboxes
              className={"hawkeye-filter-subnav-values"}
              value={selectedColumns}
              options={selectedView.metadata.columns}
              onChange={onColumnSelection}
              placeholderButtonLabel={"Select columns"}
              minWidth={"310rem"}
            />
          </div>
          <div className="hawkeye-filter-subnav-footer">
            <button onClick={toggleCheckUncheckAll} className="hawkeye-btn hawkeye-btn-primary">
              {selectedColumns.length > 0 ? "Deselect All" : "Select All"}
            </button>
            <button onClick={onSelectionCompletion} className="hawkeye-btn hawkeye-btn-primary">
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(HawkeyeV2FieldSelection);
